import $ from 'jquery';

export default class StaticCart {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);

    this.cartForm = $('#cart-form', this.el);
    this.$shippingStrings = $('[data-shipping-calculator-strings]', this.el);
    this.shippingContext = {};

    if (this.$shippingStrings.length) {
      this.countryProvinceSelector = new Shopify.CountryProvinceSelector(
        'address_country',
        'address_province',
        {
          hideElement: 'address_province_container',
        },
      );

      try {
        this.shippingContext = JSON.parse(this.$shippingStrings.text());
      } catch (error) {
        console.log('No shipping localisations found, unable to continue.');
      }

      if (this.shippingContext == null) { return; }

      if ($('[data-cart-item]', this.el).length) {
        this.shippingCalculator();
      }
    }

    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);

    $('.quantity .field', this.el).on('change.cart', this.updateQuantity.bind(this));
    $('.instructions textarea', this.el).on('change.cart', this.saveNote.bind(this));
    $('.get-rates', this.el).on('click.cart', this.calculateShipping.bind(this));
    $('#address_zip', this.el).on('keydown.cart', this.calculateShipping.bind(this));
  }

  updateQuantity(e) {
    const input = $(e.currentTarget, this.el);
    const quantity = input.val();
    const id = input.data('id');
    const url = `/cart/change/${id}?quantity=${quantity}`;

    window.location = url;
  }

  saveNote() {
    const newNote = $('.instructions textarea', this.el).val();
    // empty function so that Shopify's callback isn't invoked
    Shopify.updateCartNote(newNote, () => {});
  }

  shippingCalculator() {
    Shopify.Cart.ShippingCalculator.show({
      submitButton: this.shippingContext.submitButton,
      submitButtonDisabled: this.shippingContext.submitButtonDisabled,
      customerIsLoggedIn: this.shippingContext.customerIsLoggedIn,
      moneyFormat: this.shippingContext.moneyFormat,
    });
  }

  calculateShipping(e) {
    if (e && (e.type === 'keydown')) {
      if (e.keyCode === 13) {
        e.preventDefault();
        $('.wrapper-response', this.el).empty();
      } else {
        return;
      }
    }

    const shippingAddress = {};
    shippingAddress.zip = $('.address-zip', this.el).val() || '';
    shippingAddress.country = $('.address-country', this.el).val() || '';
    shippingAddress.province = $('.address-province', this.el).val() || '';

    Shopify.getCartShippingRatesForDestination(shippingAddress, (rates) => {
      let address = `${shippingAddress.zip}, ${shippingAddress.province}, ${shippingAddress.country}`;
      if (!shippingAddress.province.length) {
        address = `${shippingAddress.zip}, ${shippingAddress.country}`;
      }
      if (!shippingAddress.zip.length) {
        address = `${shippingAddress.province}, ${shippingAddress.country}`;
      }
      if (!shippingAddress.province.length || !shippingAddress.zip.length) {
        address = shippingAddress.country;
      }

      $('.wrapper-response', this.el)
        .empty()
        .append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");

      const ratesFeedback = $('.shipping-calculator-response', this.el);
      if (rates.length > 1) {
        const firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
        const multipleShippingRates = Theme.shippingCalcMultiRates
          .replace('--address--', address)
          .replace('--number_of_rates--', rates.length)
          .replace('--rate--', `<span class='money'>${firstRate}</span>`);
        ratesFeedback.html(multipleShippingRates);
      } else if (rates.length === 1) {
        const oneShippingRate = Theme.shippingCalcOneRate
          .replace('--address--', address);
        ratesFeedback.html(oneShippingRate);
      } else {
        ratesFeedback.html(Theme.shippingCalcNoRates);
      }

      for (let i = 0; i < rates.length; i++) {
        const rate = rates[i];
        const price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
        const rateValues = Theme.shippingCalcRateValues
          .replace('--rate_title--', rate.name)
          .replace('--rate--', `<span class='money'>${price}</span>`);
        $('.shipping-rates', this.el).append(`<li>${rateValues}</li>`);
      }
    });
  }

  handleErrors(errors) {
    let errorMessage = $.parseJSON(errors.responseText);
    errorMessage = Theme.shippingCalcErrorMessage.replace('--error_message--', errorMessage.zip);
    return $('.wrapper-response', this.el).html(`<p class='message'>${errorMessage}</p>`);
  }

  onSectionUnload() {
    $('.quantity .field', this.el).off('change.cart');
    $('.instructions textarea', this.el).off('change.cart');
    $('.get-rates', this.el).off('click.cart');
    $('#address_zip', this.el).off('keydown.cart');
  }
}
